export const goBackButton = (url) => {
    console.log('inside goBackButton', url);
    typeof url === 'string' && window.location.replace(url);
}